import { render, staticRenderFns } from "./FestivalsSingleCategory.vue?vue&type=template&id=e66c70a8&scoped=true&"
import script from "./FestivalsSingleCategory.vue?vue&type=script&lang=js&"
export * from "./FestivalsSingleCategory.vue?vue&type=script&lang=js&"
import style0 from "./FestivalsSingleCategory.vue?vue&type=style&index=0&id=e66c70a8&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66c70a8",
  null
  
)

export default component.exports